import { Spin } from "antd";
import GeneratePDF from "components/generate-pdf/GeneratePDF";
import {useEffect, useState } from 'react';
import { useParams, useSearchParams } from "react-router-dom";
import { convertToObjectKeyString } from "Utils/Common";
// import { useIntl } from 'react-intl';
import fi_translation from 'locale/fi';
import CompanyInformationServices from 'services/services/CompanyInformationServices';

var htmlPdfClient = require("html-pdf-client")

const Locale: any = {
    fi: fi_translation,
};

function GeneratePdf(props: any) {
    // const intl=useIntl();
    const [isEditable,setIsEditable] = useState<any>(true)
    const [loading,setLoading] = useState<any>(false)
    const [searchParams] = useSearchParams();
    const showbtn = searchParams.get("showbtn");
    const [customerDetails, setCustomerDetails] = useState<any>({});
    const [printBtn, setPrintBtn] = useState(false);

    useEffect (() => {
        getCustomerDetails()
    },[]);

    const generatePDF =async () => {
        var element:any = document.getElementById('report');
        setPrintBtn(true);
        var opt = {
            margin: 0.1,
            filename:     'Ador-analyysi '+ customerDetails?.customer_name.trim() + '.pdf',
            image:        { type: 'jpeg', quality: 3 },
            html2canvas:  { scale: 3.6, allowTaint: false, useCORS: true, optimized: true, letterRendering: true, logging: true},
            jsPDF:        { unit: 'pt', format: 'A4' , orientation: 'landscape',compressPDF: true },
            pagebreak:    {  after: ['.page-break'] , avoid: ['tr', 'td']}//, avoid: ['tr', 'td']

            // pagebreak:    { before: '.page-break' }
        };
        // New Promise-based usage:
        setIsEditable(false);
        setLoading(true);
        setTimeout(() => {
            htmlPdfClient().set(opt).from(element).toPdf().save();
            setIsEditable(true);
            setPrintBtn(false);
            setLoading(false);
        }, 1500);
    }

    const TranslateString = (string:any) => {
        let key:any = convertToObjectKeyString(string);
        let value = Locale['fi'][key];
        if(value===key){
            console.log('translate',"\""+key+"\": \""+string+"\",")
        }
        // return value;
        return (value===key) ? string : value;
    };


    props = {...props,...useParams()}

    function getCustomerDetails() {
        let object: any = {};
        object.customer_id = props?.id;
        setLoading(true);
        CompanyInformationServices
            .getCustomerData(object)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    setCustomerDetails(response?.data?.customer_data)
                }
                setLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
            });
    }
    
    return (
        <>
            <Spin spinning={loading} >
                <div id="report">
                    <GeneratePDF {...props} printBtn={printBtn} isEditable={isEditable} TranslateString={TranslateString}/>
                </div>
            </Spin>
            <button onClick={generatePDF} type="button" className={"btn btn-sm cu-btn-green my-3 rounded-0" + (showbtn === '0' || printBtn ? ' d-none' : '') }  disabled={loading}>{loading?TranslateString("Please Wait"):TranslateString("Export PDF")}</button>
        </>
    );
}

export default GeneratePdf;